import { render, staticRenderFns } from "./PersonalCardTypeAdd.vue?vue&type=template&id=7d8a8058&"
import script from "./PersonalCardTypeAdd.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports